var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.svgClass,staticStyle:{"font-size":"20px"},attrs:{"id":_vm.iconId}})
}
var staticRenderFns = []

export { render, staticRenderFns }